import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SidebarRightExpandIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SidebarRightExpand",
    children: [/*#__PURE__*/_jsx("path", {
      d: "m10.76 16 3.761-3.762a1.142 1.142 0 1 0-1.615-1.616l-4.57 4.57a1.14 1.14 0 0 0 0 1.616l4.57 4.57a1.14 1.14 0 0 0 1.616-.001 1.143 1.143 0 0 0 0-1.616z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M28.245 4.571H3.755A3.76 3.76 0 0 0 0 8.327v15.346a3.76 3.76 0 0 0 3.755 3.756h24.49A3.76 3.76 0 0 0 32 23.673V8.327a3.76 3.76 0 0 0-3.755-3.756M2.285 23.673V8.327c0-.81.66-1.47 1.47-1.47h17.96v18.287H3.755c-.81 0-1.47-.66-1.47-1.471m27.43 0c0 .81-.66 1.47-1.47 1.47H24V6.858h4.245c.81 0 1.47.66 1.47 1.47z"
    })]
  }));
};
SidebarRightExpandIcon.displayName = 'SidebarRightExpandIcon';